import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavService } from '../../core/nav.service';
import { ListObservable } from '../../shared/base/list-observable';
import { ObjectObservable } from '../../shared/base/object-observable';
import { Course } from '../shared/course';
import { CourseLectureService } from '../shared/course-lecture.service';
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-course-detail',
  templateUrl: './course-detail.component.html'
})
export class CourseDetailComponent implements OnInit, OnDestroy {
  courseObservable: ObjectObservable<Course>;
  lecturesObservable: ListObservable<any>;
  AppConfig: any;

  constructor(private route: ActivatedRoute, private nav: NavService, private refService: CourseLectureService) { }

  ngOnInit() {
    this.initNav();
    this.route.data.subscribe((data: { course: ObjectObservable<Course> }) => this.courseObservable = data.course);
    this.route.params.subscribe(({ id }) => this.lecturesObservable = this.refService.readList(id));
    this.AppConfig = APPCONFIG;
  }

  ngOnDestroy() {
    this.nav.title = null;
    this.nav.actions = null;
  }

  private initNav() {
    this.nav.title = '강좌 내용';
    this.nav.actions = [
      { text: 'arrow_back', commands: ['/courses'] }
    ];
  }

  get title() {
    return this.nav.title;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-detail/course-detail.component.ts